import DataLoadError, {
  DataLoadDefaultErrors,
} from "../../../../utils/data-load-error/data-load-error";

export enum OrderCancelRevertRequestErrorType {
  ORDER_CANCELLED = "ORDER_CANCELLED",
  ORDER_CANCEL_NOT_REQUESTED = "ORDER_CANCEL_NOT_REQUESTED",
  ORDER_FINISHED = "ORDER_FINISHED",
}

export type OrderCancelRevertRequestOrderCancelledError = DataLoadError<
  OrderCancelRevertRequestErrorType.ORDER_CANCELLED,
  {}
>;

export type OrderCancelRevertRequestOrderCancelNotRequestedError =
  DataLoadError<
    OrderCancelRevertRequestErrorType.ORDER_CANCEL_NOT_REQUESTED,
    {}
  >;

export type OrderCancelRevertRequestFinishedError = DataLoadError<
  OrderCancelRevertRequestErrorType.ORDER_FINISHED,
  {}
>;

type OrderCancelRevertRequestError =
  | DataLoadDefaultErrors
  | OrderCancelRevertRequestOrderCancelledError
  | OrderCancelRevertRequestOrderCancelNotRequestedError
  | OrderCancelRevertRequestFinishedError;

export default OrderCancelRevertRequestError;
